export const BUSINESS_URL = '/business';
